import React, { useState, useMemo, useEffect} from "react";
import styled from "styled-components";
import { useToastContext } from "@/contexts/ToastContext";
import { ReactSVG } from "react-svg";
import classnames from "classnames";
import {useAccount, useContractWrite, useProvider, usePrepareContractWrite, useContractRead} from "wagmi";
import {ethers} from "ethers";
import { NFTCA, WARRIOR_NFT, nftAbi, synthAbi, topicEventCA } from '@/utils/abi'
import Spinner from '@/components/Spinner'
import NftCard from '@/components/NftCard'
import plusImage from '@/assets/svg/plus.svg'

function SynthModal({ config, squads, loading, onMint}) {
  const { showToast } = useToastContext();
  const [ current, setCurrent] = useState(0);
  const [ approved, setApproved] = useState();
  const [ selected, setSelected] = useState([]);
  const { address } = useAccount();

  const {isLoading} = useContractRead({
    address: NFTCA,
    abi: nftAbi,
    functionName: 'isApprovedForAll',
    args: [address, WARRIOR_NFT],
    onSuccess(data) {
      setApproved(data)
    }
  })

  const { writeAsync: writeAsyncApprove, isLoading: isApproving } = useContractWrite({
    mode: 'recklesslyUnprepared',
    address: NFTCA,
    abi: nftAbi,
    functionName: 'setApprovalForAll',
    args: [WARRIOR_NFT, true],
  })

  const { writeAsync: writeAsyncMintBeast, isLoading: isMintingBeast} = useContractWrite({
    mode: 'recklesslyUnprepared',
    address: WARRIOR_NFT,
    abi: synthAbi,
    functionName: 'redeemCyberBeast',
  })

  const { writeAsync: writeAsyncMintKnight, isLoading: isMintingKnight} = useContractWrite({
    mode: 'recklesslyUnprepared',
    address: WARRIOR_NFT,
    abi: synthAbi,
    functionName: 'redeemNeonKnight',
  })

  const synthConfig = config?.synth || []

  const currentConfig = useMemo(() => {
    return synthConfig[current]
  }, [current])

  const currentSelect= useMemo(() => {
    return selected[current]
  }, [current])


  const currentList= useMemo(() => {
    if(current === undefined) {
      return []
    }
    const config = synthConfig[current]
    const type = config.type
    return squads.filter((squad) => {
      return Array.isArray(type) ? type.includes(squad.type) : squad.type === type
    })
  }, [current, squads])

  const canMint= useMemo(() => {
    return synthConfig.every((_, index) => {
      return selected[index] !== undefined
    })
  }, [selected])

  const handleSelectChange = (e) => {
    const value = e.target.value
    setSelected(selected.map((item, index) => index === current ? value : item))
  }

  const handleApprove = async () => {
    try {
      const approveR = await writeAsyncApprove()
      const approveWait = await approveR.wait()
      if(approveWait?.status === 1){
        setApproved(true)
      }
    }catch (e) {
      showToast({
        dir:'top',
        type:'error',
        text:'Fail，Please try again'
      })
    }
  }

  const handleMint = async () => {
    const method = synthConfig.length === 6 ? writeAsyncMintKnight : writeAsyncMintBeast
    console.log(selected);
    try {
      const mintTX= await method({
        recklesslySetUnpreparedArgs: selected
      })
      const result = await mintTX.wait()
      if(result?.status === 1){
        const logs = (result?.logs || []).filter(item => item?.topics[0] === topicEventCA && item?.topics?.length === 4)
        const tokenId = parseInt(
          logs[logs.length-1].topics[3]
        )
        onMint(tokenId)
      }
    }catch (e) {
      showToast({
        dir:'top',
        type:'error',
        text:'Fail，Please try again'
      })
    }
  }

  useEffect(() => {
    const selectedTokenIds =  synthConfig.map(({type}) => {
      const item = squads.find(squad => {
        return Array.isArray(type) ? type.includes(squad.type) : squad.type === type
      })
      return item ? `${item.tokenId}` : undefined
    })
    setSelected(selectedTokenIds)
    // const hasNotSelected= selectedTokenIds.some((id) => {
    //   return id === undefined
    // });
    //
    // if(!loading && hasNotSelected) {
    //   showToast({
    //     dir:'top',
    //     type:'error',
    //     text:'Combination Invalid!'
    //   })
    // }
  }, [squads]);


  return (
    <Spinner loading={loading || isLoading}>
      <Wrapper>
        <div className="modal-head">
          {
            approved ? <>
              <div className="modal-title">Minting {config?.title}...</div>
              <div className="modal-desc">The NFT required for synthesis has been automatically selected for you. You can click on the avatar of the NFT below to change it.</div>
            </> : (<div className="modal-desc-approve">To get set up for Jungle Squad synthesis for the first time, you must approve tokens for contract interaction, which requires a one-time gas fee.</div>)
          }
        </div>
        <Nav>
          {synthConfig.map((config, index) => {
            return <div key={index} onClick={() => setCurrent(index)}
                        className={classnames('nav-item', {'active': current === index})}>
              <img src={config.info.poster}/>
              {selected[index] === undefined && <div className="nav-item-cover">
                <ReactSVG src={plusImage}></ReactSVG>
              </div>}
            </div>
          })}
        </Nav>
        <div className="select-title">
          {
            currentConfig && <>{currentConfig.info.name}: {currentSelect ? `#${currentSelect} selected` : 'not selected'}</>
          }
        </div>
        <div className="select-container">
          {currentList.map((item) => {
            return <NftCard tokenId={item.tokenId} type={item.type} key={item.tokenId}>
              <label>
                <input type="radio" name={`${item.type}`} value={item.tokenId} checked={
                  selected.includes(`${item.tokenId}`)
                } onChange={(e) => handleSelectChange(e)}/>
              </label>
            </NftCard>
          })}
          {
            currentConfig && !currentList.length && <div className="select-tips">
              No {currentConfig.info.name} NFT founded in your address
            </div>
          }
        </div>
        <div className="btn-container">
          {!approved && <button className={classnames('btn-mint', {loading: isApproving})} disabled={!canMint || isApproving}
                   onClick={handleApprove}>{isApproving ? 'Approving' : 'Approve'}</button>}
          {approved && <button className={classnames('btn-mint', {loading: isMintingBeast || isMintingKnight})} disabled={!canMint || isMintingBeast || isMintingKnight}
                   onClick={handleMint}>{isMintingBeast || isMintingKnight ? 'Minting' : 'Mint Now'}</button>}
        </div>

      </Wrapper>
    </Spinner>
  )
}
export default SynthModal;

const Wrapper = styled.div`
  position: relative;
  
  .modal-head {
    display: flex;
    height: 76px;
    justify-content: center;
    flex-direction: column;
  }
  
  .modal-title {
    font-size: 30px;
    line-height: 42px;
    font-weight: 600;
    color: #32DE86;
    margin-bottom: 6px;
  }
  
  .modal-desc {
    font-size: 20px;
    line-height: 28px;
    color: rgba(255, 255, 255, 0.6);
  }
  
  .modal-desc-approve {
    font-size: 20px;
    line-height: 28px;
    color: #32DE86;
    margin-right: 150px;
  }
  
  .select-title {
    margin: 20px 0;
    font-size: 20px;
    line-height: 28px;
    height: 28px;
    color: #FFFFFF;
  }
  
  .select-tips {
    height: 315px;
    display: flex;
    align-items: center;  
    justify-content: center;
    width: 100%;
  }
  
  .select-container {
    height: 315px;
    overflow: auto;
    display: flex;
    label {
      position: absolute;
      left: 0;top: 0;right: 0;bottom: 0;
      cursor: pointer;
    }
    
    input {
      position: absolute;
      right: 18px;
      top: 18px;
      width: 20px;
      height: 20px;
      box-sizing: border-box;
      appearance: none;
      background: rgba(255,255,255,.3);
      border: 2px solid #000000;
      border-radius: 4px;
      margin: 0;
      transition: all .35s ease;
      
      &:checked {
        background: rgba(0,0,0,.8);
        border-color: rgba(0,0,0,.8);
        :before {
          position: absolute;
          content: "";
          width: 4px;
          height: 9px;
          top: 1px;
          left: 5px;
          border: 2px solid #32DE86;
          border-top: none;
          border-left: none;
          transform: rotate(45deg);
        }
      }
    }
  }
  
  .btn-mint {
    height: 44px;
    padding: 0 60px;
    min-width: 380px;
    color: #fff;
    border: none;
    background: #32DE86;
    border-radius: 8px;
    font-size: 16px;
    font-weight: 600;
    cursor: pointer;
    
    &[disabled] {
      background: #ddd;
    }

    &.loading,
    &.loading[disabled] {
      background: rgba(50, 222, 134, 0.3);
    }
  }
  
  .btn-container {
    text-align: center;
    padding-top: 12px;
  }
`;

const Nav = styled.div`
  position: relative;
  padding: 32px 0 25px 0;
  border-bottom: 1px solid rgba(255, 255, 255, 0.15);
  display: flex;
  justify-content: space-between;
  
  .nav-item {
    border-radius: 10px;
    overflow: hidden;
    border: 2px solid transparent;
    transition: all .35s ease;
    cursor: pointer;
    position: relative;
    
    img {
      width: 118px;
      height: 118px;
      display: block;
    }
    
    &.active {
      border-color: #32DE86
    }
  }
  
  .nav-item-cover {
    position: absolute;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(255,255,255,.8);
    display: flex;
    align-items: center;
    justify-content: center;
  }
`;

